import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { toast } from '../../../lib/toast';
import { deleteContact } from '../api/contacts';

export function useDeleteContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteContact(id),
    onSuccess: (_data, id) => {
      invalidateListResource(queryClient, 'contacts');
      if (id) {
        queryClient.invalidateQueries({ queryKey: ['contact', id] });
      }
      toast.success('Contact deleted');
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to delete contact');
    },
  });
}

